
export interface IRLFocusScope extends ng.IScope {
    show: boolean;
}

RLFocus.$inject = ["$timeout"];
export function RLFocus($timeout: ng.ITimeoutService) {
    var directive: ng.IDirective = {
        restrict: "A",
        scope: {
            show: '=rlFocus'
        },
        link: (scope: IRLFocusScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            scope.$watch(() => scope.show, (newValue) => {
                $timeout(() => {
                    if (newValue) {
                        element.focus();
                    }
                }, 200);
            });
        }
    }

    return directive;
}
